<template>
  <div>
    <div class="purchase_pupop">
      <div v-loading="loading" class="purchase_form" style="position: relative">
        <div
          style="
            position: absolute;
            right: 30px;
            top: 30px;
            font-size: 30px;
            color: #606266;
            cursor: pointer;
          "
          @click="back"
        >
          <i class="el-icon-circle-close" />
        </div>
        <div class="xkzxx">
          <div class="title">
            <img src="../../assets/img/xkzxx.png" alt="" srcset="">
          </div>
          <el-form
            ref="Top_xkzxxForm"
            label-position="right"
            :model="xkzxxForm"
            label-width="120px"
            :rules="rules_top"
          >
            <el-form-item class="is-required" label="进口许可证:" prop="jkzBh">
              <el-input
                v-model="xkzxxForm.jkzBh"
                disabled
                placeholder="请选择进口证明"
              />
              <el-button
                v-preventReClick
                class="xuanze"
                :disabled="bgdisable || ckdisable"
                @click="initGmzOrYszList(1)"
              >选择</el-button>
            </el-form-item>
            <el-form-item
              class="is-required"
              label="运输许可证:"
              prop="yszBh"
              :rules="{
                required: true,
                validator: (rule, value, callback) => {
                  lengthValidate(rule, xkzxxForm.yszBh, callback, 'bt', 30);
                },
                trigger: ['blur', 'change'],
              }"
            >
              <div style="position: relative; width: 100%">
                <el-select
                  v-model="xkzxxForm.yszBh"
                  :disabled="bgdisable || ckdisable"
                  style="width: calc(100% - 80px)"
                  placeholder="请选择"
                  @change="hyszxkchange"
                >
                  <el-option label="同市运输" value="同市运输" />
                </el-select>
                <el-input
                  v-model="xkzxxForm.yszBh"
                  style="position: absolute; width: calc(100% - 115px); left: 0"
                  :disabled="bgdisable || ckdisable"
                  placeholder="请输入运输证"
                  @input="hinputYSZ"
                />
                <el-button
                  v-preventReClick
                  class="xuanze"
                  :disabled="bgdisable || ckdisable"
                  @click="initGmzOrYszList(2)"
                >选择</el-button>
              </div>
            </el-form-item>
            <!--1.5号要求去掉必填校验 prop="xsckBh" -->
            <!-- <el-form-item label="进口出库编号:">
              <el-select
                :disabled="bgdisable || ckdisable"
                style="width: 100%"
                v-model="xkzxxForm.xsckBh"
                placeholder=""
                @change="hxsckbhXLchange"
              >
                <el-option
                  v-for="item in xsckDtoList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item class="is-required" label="化学品:" prop="hxpMc">
              <el-input
                v-model="xkzxxForm.hxpMc"
                style="width: 100%"
                disabled
                placeholder=""
              />
            </el-form-item>
          </el-form>
        </div>
        <div class="rkxx">
          <div class="title">
            <img src="../../assets/img/rkxx.png" alt="" srcset="" style="height: 25px;">
          </div>
          <el-form
            ref="Bottom_xkzxxForm"
            label-width="112px"
            :model="xkzxxForm"
            label-position="right"
            :rules="rules"
          >
            <el-form-item
              label="承运单位名称:"
              prop="cydwMc"
              :rules="{
                validator: (rule, value, callback) => {
                  lengthValidate(rule, value, callback, 'xt', 200);
                },
                trigger: ['blur', 'change'],
              }"
            >
              <el-input
                v-model="xkzxxForm.cydwMc"
                :disabled="bgdisable || ckdisable"
              />
            </el-form-item>
            <el-form-item
              label="承运单位统一社会信用代码："
              label-width="210px"
              prop="cydwTyxydm"
              :rules="{
                validator: (rule, value, callback) => {
                  lengthValidate(rule, value, callback, 'xt', 100);
                },
                trigger: ['blur', 'change'],
              }"
            >
              <el-input
                v-model="xkzxxForm.cydwTyxydm"
                :disabled="bgdisable || ckdisable"
              />
            </el-form-item>
            <el-form-item
              label="车次号:"
              style="position: relative"
              prop="cch"
              :rules="{
                validator: (rule, value, callback) => {
                  lengthValidate(rule, value, callback, 'xt', 300);
                },
                trigger: ['blur', 'change'],
              }"
            >
              <el-input
                v-model="xkzxxForm.cch"
                :disabled="bgdisable || ckdisable"
              />
              <div
                style="
                  position: absolute;
                  right: 2px;
                  top: 0;
                  cursor: pointer;
                  font-size: 20px;
                  color: #5b96ee;
                  height: 30;
                  width: 40px;
                  background: white;
                  margin-top: 4px;
                  text-align: center;
                  line-height: 30px;
                "
                :title="xkzxxForm.cch"
              >
                <i class="el-icon-more" />
              </div>
            </el-form-item>
            <el-form-item
              v-if="!ckdisable"
              class="is-required"
              label="存放仓库:"
              prop="ckId"
            >
              <el-select
                v-model="xkzxxForm.ckId"
                placeholder="请选择"
                style="width: 100%"
                :disabled="ckdisable"
                @change="cfckChange"
              >
                <el-option
                  v-for="item in cangkuxiala"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item
              v-else
              class="is-required"
              label="存放仓库:"
              prop="ckId"
            >
              <el-input
                v-model="xkzxxForm.ckmc"
                :disabled="true"
                style="width: 100%"
              />
            </el-form-item>
            <el-form-item
              class="is-required"
              label="保管员:"
              disabled
              prop="bgyxm"
            >
              <el-input
                v-model="xkzxxForm.bgyxm"
                :disabled="true"
                style="width: 100%"
              />
            </el-form-item>
            <el-form-item
              class="is-required"
              label="出口单位名称:"
              prop="ckdwMc"
              :rules="{
                required: true,
                validator: (rule, value, callback) => {
                  lengthValidate(rule, value, callback, 'bt', 200);
                },
                trigger: ['blur', 'change'],
              }"
            >
              <el-input
                v-model="xkzxxForm.ckdwMc"
                :disabled="bgdisable || ckdisable"
              />
            </el-form-item>
            <el-form-item
              class="is-required"
              label="出口单位代码:"
              prop="ckdwTyxydm"
              :rules="{
                required: true,
                validator: (rule, value, callback) => {
                  lengthValidate(rule, value, callback, 'bt', 100);
                },
                trigger: ['blur', 'change'],
              }"
            >
              <el-input
                v-model="xkzxxForm.ckdwTyxydm"
                :disabled="bgdisable || ckdisable"
              />
            </el-form-item>
            <!-- <el-form-item
              label="出口单位行政区划:"
              label-width="129px"
              prop="ckdwXzqh"
              :rules="{
                validator: (rule, value, callback) => {
                  lengthValidate(rule, value, callback, 'xt', 500);
                },
                trigger: ['blur', 'change'],
              }"
            >
              <div style="display: flex; width: 100%">
                <el-input
                  :disabled="bgdisable || ckdisable"
                  v-model="xkzxxForm.ckdwXzqh"
                  placeholder="请输入"
                ></el-input>
              </div>
            </el-form-item> -->
            <el-form-item label="可入库数量:">
              <el-input
                v-model="xkzxxForm.krked"
                style="width: 60%"
                disabled
              />
              <el-input
                v-model="xkzxxForm.krkedDwLabel"
                style="width: 35%; margin-left: 5%"
                disabled
                placeholder="单位"
              />
            </el-form-item>
            <el-form-item label="起运数量:" prop="qysl">
              <!-- :disabled="bgdisable || ckdisable" @y2022/1/11 文静 起运数量可变更  -->
              <el-input
                v-model="xkzxxForm.qysl"
                style="width: 60%"
                placeholder="请输入"
                :disabled="ckdisable"
                @input="hshuliangjS"
              />
              <el-input
                v-model="xkzxxForm.qyslDwLabel"
                style="width: 35%; margin-left: 5%"
                disabled
                placeholder="单位"
              />
            </el-form-item>
            <el-form-item prop="rksl" label="入库数量:">
              <el-input
                v-model="xkzxxForm.rksl"
                style="width: 60%"
                placeholder="请输入"
                :disabled="ckdisable"
                @input="hshuliangjS"
              />
              <el-select
                v-model="xkzxxForm.rkslDw"
                :disabled="ckdisable"
                placeholder="单位"
                style="width: 35%; margin-left: 5%"
                @change="hdanweichange"
              >
                <el-option
                  v-for="(item, index) in ckslList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="耗损数量:">
              <el-input
                v-model="xkzxxForm.shsl"
                disabled
                style="width: 60%"
                placeholder="请输入"
              />
              <el-input
                v-model="xkzxxForm.shslDwLabel"
                style="width: 35%; margin-left: 5%"
                disabled
                placeholder="单位"
              />
            </el-form-item>
            <el-form-item
              label="耗损原因:"
              disabled
              prop="shyy"
              :rules="{
                validator: (rule, value, callback) => {
                  lengthValidate(rule, value, callback, 'xt', 500);
                },
                trigger: ['blur', 'change'],
              }"
            >
              <el-input
                v-model="xkzxxForm.shyy"
                :disabled="bgdisable || ckdisable"
              />
            </el-form-item>
            <el-form-item class="is-required" label="入库日期:" prop="rkrq">
              <el-date-picker
                v-model="xkzxxForm.rkrq"
                :picker-options="pickerBeginDateBefore"
                :disabled="ckdisable"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"
              />
            </el-form-item>
            <el-form-item class="is-required" label="经办人:" prop="jbrName">
              <el-select
                v-model="xkzxxForm.jbrName"
                filterable
                placeholder="选择经办人"
                style="width: 100%"
                :disabled="bgdisable || ckdisable"
                @change="hjbrChange"
              >
                <el-option
                  v-for="item in jingbanrenlist"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item class="is-required" disabled label="登记人:">
              <el-input v-model="xkzxxForm.djrLabel" disabled />
            </el-form-item>
            <el-form-item
              v-if="djsjshow"
              class="is-required"
              disabled
              label="登记时间:"
              prop="djsj"
            >
              <el-date-picker
                v-model="xkzxxForm.djsj"
                disabled
                type="date"
                placeholder="选择日期"
              />
            </el-form-item>
            <el-form-item v-else label="登记时间:">
              <el-date-picker
                :value="new Date()"
                type="date"
                style="width: 407px"
                placeholder="选择日期"
                disabled
                format="yyyy-MM-dd HH:mm:ss"
              />
            </el-form-item>
            <el-form-item
              label="备注:"
              style="width: 100%"
              prop="bz"
              :rules="{
                validator: (rule, value, callback) => {
                  lengthValidate(rule, value, callback, 'xt', 225);
                },
                trigger: ['blur', 'change'],
              }"
            >
              <el-input
                v-model="xkzxxForm.bz"
                :disabled="bgdisable || ckdisable"
                placeholder="请输入"
                style="width: 100%"
              />
            </el-form-item>
            <el-form-item
              v-if="bgdisable"
              label="变更理由:"
              style="width: 100%"
              class="is-required"
              prop="bgly"
              :rules="{
                required: true,
                validator: (rule, value, callback) => {
                  lengthValidate(rule, value, callback, 'bt', 1000);
                },
                trigger: ['blur', 'change'],
              }"
            >
              <el-input
                v-model="xkzxxForm.bgly"
                placeholder="请输入"
                style="width: 100%"
              />
            </el-form-item>
          </el-form>
          <div
            v-if="
              xkzxxForm.bgcs == 0 ||
                !xkzxxForm.bgcs ||
                (!djsjshow && !bgdisable && !ckdisable)
            "
          >
            <!-- 新增 -->
            <div
              v-if="!djsjshow && !bgdisable && !ckdisable"
              class="buttonList"
            >
              <el-button class="zsbc" @click="ZSsave">暂时保存</el-button>
              <el-button class="tjsq" @click="htjsq">入库</el-button>
            </div>
            <!-- 查看 -->
            <div v-if="djsjshow && !bgdisable && ckdisable" class="buttonList">
              <el-button
                class="tjsq"
                @click="$parent.pupopShow = false"
              >确定</el-button>
            </div>
            <!-- 变更 -->
            <div v-if="djsjshow && bgdisable && !ckdisable" class="buttonList">
              <el-button
                v-preventReClick
                class="tjsq"
                @click="htjbg"
              >提交变更</el-button>
            </div>
            <!-- 编辑  -->
            <div v-if="djsjshow && !bgdisable && !ckdisable" class="buttonList">
              <el-button class="zsbc" @click="ZSsave">暂时保存</el-button>
              <el-button class="tjsq" @click="htjsq">提交申请</el-button>
            </div>
          </div>
        </div>
        <div
          v-if="xkzxxForm.bgcs > 0 && !(!djsjshow && !bgdisable && !ckdisable)"
          class="rkxx"
        >
          <div class="title">
            <img src="../../assets/img/bgsp/rkbg.png" alt="" srcset="">
          </div>
          <bgcsOfDetail
            :cur-row-obj="xkzxxForm"
            :cur-type="'19'"
            :bgcs-t-k-name="'disShow'"
            @bacsCkXqShow="bacsCkXqShow"
          />
          <div>
            <!-- 新增 -->
            <div
              v-if="!djsjshow && !bgdisable && !ckdisable"
              class="buttonList"
            >
              <el-button class="zsbc" @click="ZSsave">暂时保存</el-button>
              <el-button class="tjsq" @click="htjsq">入库</el-button>
            </div>
            <!-- 查看 -->
            <div v-if="djsjshow && !bgdisable && ckdisable" class="buttonList">
              <el-button
                v-preventReClick
                class="tjsq"
                @click="$parent.pupopShow = false"
              >确定</el-button>
            </div>
            <!-- 变更 -->
            <div v-if="djsjshow && bgdisable && !ckdisable" class="buttonList">
              <el-button
                v-preventReClick
                class="tjsq"
                @click="htjbg"
              >提交变更</el-button>
            </div>
            <!-- 编辑  -->
            <div v-if="djsjshow && !bgdisable && !ckdisable" class="buttonList">
              <el-button class="zsbc" @click="ZSsave">暂时保存</el-button>
              <el-button class="tjsq" @click="htjsq">提交申请</el-button>
            </div>
          </div>
        </div>
      </div>
      <!-- 证件弹框 -->
      <el-dialog
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        title=""
        :visible.sync="dialogVisible"
        center
      >
        <div>
          <el-form
            class="t_search_form"
            style="margin-left: auto; margin-right: auto"
            label-position="center"
            label-width="90px"
          >
            <el-form-item
              v-if="dialogType == 1"
              label="许可证类型"
              prop="searchCertType"
            >
              <el-select v-model="searchCertType">
                <el-option value="G" label="购买证" />
                <el-option value="J" label="进口核查证" />
              </el-select>
            </el-form-item>
            <el-form-item
              :label="dialogType == 1 ? '进口证编号:' : '运输证编号:'"
            >
              <el-input
                v-model="bgform.param.xkzBh"
                placeholder="请输入"
                clearable
              />
            </el-form-item>
            <el-form-item v-if="dialogType == 1" label="化学品:">
              <el-input
                v-model="bgform.param.hxpMc"
                placeholder="请输入"
                clearable
              />
            </el-form-item>
            <el-button
              class="sousuoButton"
              icon="el-icon-search"
              round
              size="small"
              type="primary"
              @click="searchByForm"
            >搜索</el-button>
          </el-form>
          <el-table
            ref="xsckTable"
            :data="tableData"
            :header-cell-style="{ background: '#f4f4f4', color: '#909399' }"
            border
            :show-overflow-tooltip="true"
            style="
              width: 100%;
              border-left: 1px solid #f4f4f4;
              border-right: 1px solid #f4f4f4;
            "
            :header-cell-class-name="cellClass"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" align="center" width="55" />
            <el-table-column
              v-for="(item, i) in tableText"
              :key="i"
              :show-overflow-tooltip="true"
              align="center"
              :label="item.label"
              :prop="item.key"
            >
              <template slot-scope="scope">
                <span :title="scope.row[item.key]">
                  {{
                    item.key == "hzsl" && scope.row["fhdwMc"]
                      ? scope.row[item.key] + scope.row["hzslDwMc"]
                      : item.key == "hzsl" && !scope.row["fhdwMc"]
                        ? scope.row[item.key] + scope.row["hzslDwMc"]
                        : scope.row[item.key]
                  }}
                </span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          background
          layout="prev, pager,next,jumper,total,sizes"
          :page-sizes="[10, 20, 30, 40]"
          :total="total"
          :page-size="bgform.size"
          :current-page.sync="bgform.page"
          class="el-page"
          @size-change="pagesizeChangeYszOrGmz($event, dialogType)"
          @current-change="handleCurrentChangeYszOrGmz($event, dialogType)"
        />
        <div slot="footer">
          <el-button
            v-preventReClick
            @click="dialogVisible = false"
          >取 消</el-button>
          <el-button
            v-preventReClick
            type="primary"
            @click="hqueding"
          >确 定</el-button>
        </div>
      </el-dialog>
      <!-- <bgcs
      :bgwindow="bgwindow"
      :bgcsTKName="bgcsTKName"
      @closeBindWarnStandard="handleCloseBindWarnStandard"
    /> -->
    </div>
    <div v-if="dialogFormVisible" class="purchase_pupop">
      <!-- 详情弹框 -->
      <el-dialog :visible.sync="dialogFormVisible" width="1200px" center>
        <bgxqCom
          v-if="dialogFormVisible"
          :bgcs-t-k-name="bgcsTKName"
          :dgcs-xq-id="dgcsXqId"
        />
        <div slot="footer" class="dialog-footer">
          <el-button
            v-preventReClick
            type="primary"
            style="background-color: #4170ff; border: none"
            @click="dialogFormVisible = false"
          >确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { lengthValidate } from '@/assets/js/validate'
import bgcsOfDetail from '../bgxq/bgInDetail.vue'
import bgxqCom from '../bgxq/bgxqCom.vue'
import {
  APIcangku, // 仓库下拉
  APIjingbanren // 经办人
} from '@/assets/js/wangshuai.js'
import { getJKZList, getYSZList, getJKZ, addOrUpdSaveJKRK, getJKRK, changePdkc, saveChangeApply } from '@/assets/js/jkrk.js'
import { gethqdw } from '@/assets/js/ccgl.js' // 单位获取
import { userInfofLogin } from '@/assets/js/common.js'
export default {
  components: { bgcsOfDetail, bgxqCom },
  props: ['djsjshow', 'bgdisable', 'ckdisable', 'xkzBh'],
  data() {
    // 进口证明非空校验
    const jkzValidate = (rule, value, callback) => {
      if (!this.xkzxxForm.jkzBh) {
        return callback(new Error('请选择进口证明编号'))
      }
      callback()
    }
    // 起运数量校验
    const qyslValidate = (rule, value, callback) => {
      if (!(this.xkzxxForm.qysl + '')) {
        return callback(new Error('请填写起运数量'))
      }
      // else if (this.xkzxxForm.qysl < 0) {
      //   return callback(new Error("请填写不小于0的起运数量值"));
      // }
      const reg = /^(0|[1-9][0-9]*)(\.\d+)?$/
      if (!reg.test(this.xkzxxForm.qysl)) {
        callback(new Error('请输入大于或等于0的数量值'))
      } else if (
        /^[1-9]\d{0,8}(\.\d{1,3})?$|^0(\.\d{1,3})?$/.test(value) == false
      ) {
        return callback(new Error('整数位最大长度9位,保留3位小数'))
      }
      // else if (
      //   this.xkzxxForm.shsl * 1 < 0 &&
      //   this.xkzxxForm.shsl * 1 !== 0 &&
      //   this.xkzxxForm.rksl &&
      //   !this.bgdisable
      // ) {
      //   // 起运数量必须大于入库数量 并且是新增的时候 变更的时候 只校验入库数量 (起运数量不能编辑)
      //   return callback(new Error("起运数量必须不小于入库数量"));
      // }
      callback()
    }
    // 入库数量校验
    const rkslValidate = (rule, value, callback) => {
      /*
      @y 2022/1/10需要校验的内容
      新增=>{
        1.入库数量必填
        2.入库数量单位必填
        3.入库数量必须小于可进口额度
        4.入库数量必须小于起运数量
        5.小数取三位小数
        6.输入的数值可以为0
      }
      变更=>{
        只需要校验是必填
      }
      */
      if (!(this.xkzxxForm.rksl + '')) {
        return callback(new Error('请填写入库数量'))
      }
      //  else if (this.xkzxxForm.rksl < 0) {
      //   return callback(new Error("请填写不小于0的入库数量值"));
      // }
      const reg = /^(0|[1-9][0-9]*)(\.\d+)?$/
      if (!reg.test(this.xkzxxForm.rksl)) {
        callback(new Error('请输入大于或等于0的数量值'))
      } else if (
        /^[1-9]\d{0,8}(\.\d{1,3})?$|^0(\.\d{1,3})?$/.test(value) == false
      ) {
        return callback(new Error('整数位最大长度9位,保留3位小数'))
      } else if (!this.xkzxxForm.rkslDw) {
        return callback(new Error('请选择入库数量单位'))
      } else if (!this.bgdisable && !this.ckdisable) {
        // 判断可进口额度
        let rksl_hs = null
        if (this.xkzxxForm.rkslDw == '毫升' || this.xkzxxForm.rkslDw == '克') {
          rksl_hs = this.xkzxxForm.rksl
        } else if (
          this.xkzxxForm.rkslDw == '升' ||
          this.xkzxxForm.rkslDw == '千克'
        ) {
          rksl_hs = this.xkzxxForm.rksl * 1000
        } else if (this.xkzxxForm.rkslDw == '吨') {
          rksl_hs = this.xkzxxForm.rksl * 1000 * 1000
        }
        if (rksl_hs > this.temp_kgmed) {
          return callback(new Error('入库数量必须不大于可入库数量'))
        }
        //  else if (
        //   this.xkzxxForm.shsl * 1 < 0 &&
        //   this.xkzxxForm.qysl &&
        //   this.xkzxxForm.shsl * 1 !== 0
        // ) {
        //   return callback(new Error("入库数量必须不大于起运数量"));
        // }
      }
      callback()
    }

    return {
      searchCertType: 'J',
      loading: false,
      dgcsXqId: null,
      dialogFormVisible: false,
      curType: '',
      curRowObj: {}, // 当前行的对象
      bgcsTKName: '进口入库',
      bgwindow: false,
      temp_rksldw_hs: '', // 临时的入库数量单位换算@y
      temp_kgmed: null, // 临时的可进口额度@y
      djr: '',
      bgform: {
        page: 1,
        size: 1,
        param: {
          hxpMc: '',
          xkzBh: '',
          beginRkrq: '',
          endRkrq: '',
          zt: ''
        }
      },
      total: 0,
      searchForm: [],
      // 日期限制
      pickerBeginDateBefore: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        }
      },
      cangkuxiala: [], // 仓库名称下拉
      // 日期限制
      dialogVisible: false,
      yssl: '',
      gmsl: '',
      sqsl: '',

      // 提交数据
      xkzxxForm: {
        id: '',
        dwId: '',
        rkbh: '',
        jkzId: '',
        jkzBh: '',
        xsckId: '',
        xsckBh: '',
        yszId: '',
        yszBh: '',
        hxpBm: '',
        hxpMc: '',
        ckId: '',
        ckmc: '',
        rksl: '',
        rkslDw: '',
        zt: '',
        bz: '',
        cydwMc: '',
        cydwTyxydm: '',
        cch: '',
        ckdwMc: '',
        ckdwTyxydm: '',
        ckdwXzqh: '',
        qysl: '',
        qyslDw: '',
        shsl: '',
        shslDw: '',
        shyy: '',
        bgyId: '',
        bgyxm: '',
        bgydh: '',
        jbrId: '',
        jbrName: '',
        rkrq: '',
        bgly: ' '
      },
      dialogType: '',
      table1: [
        {
          key: 'xkzBh',
          label: '进口证明编号'
        },
        {
          key: 'hxpMc',
          label: '化学品名称'
        },
        {
          key: 'hzsl',
          label: '进口数量'
        },
        {
          key: 'yt',
          label: '用途'
        },
        {
          key: 'xsdwMc',
          label: '出口单位'
        },
        {
          key: 'hfrq',
          label: '审批日期'
        }
        // {
        //   key: "zt",
        //   label: "状态",
        // },
      ],
      table2: [
        {
          key: 'xkzBh',
          label: '许可证编号'
        },
        {
          key: 'hxpMc',
          label: '化学品名称'
        },
        {
          key: 'hzsl',
          label: '运输数量'
        },
        {
          key: 'fhdwMc',
          label: '发货单位'
        },
        {
          key: 'cjsj',
          label: '申请日期'
        }
      ],

      // 输入框校验
      rules_top: {
        jkzBh: [
          {
            required: true,
            validator: jkzValidate,
            trigger: 'blur'
          }
        ]
        // yszBh: [{ required: true, validator: yszValidate, trigger: "blur" }],
      },
      // 弹框校验
      rules: {
        // 输入框

        hxpMc: [
          { required: true, message: '请输入化学品名称', trigger: 'blur' }
        ],
        bgyxm: [
          { required: true, message: '请输入保管员姓名', trigger: 'blur' }
        ],
        // ckdwMc: [
        //   { required: true, message: "请输入出口单位名称", trigger: "blur" },
        // ],
        // ckdwTyxydm: [
        //   {
        //     required: true,
        //     message: "请输入出口单位统一信用代码",
        //     trigger: "blur",
        //   },
        // ],
        qysl: [
          {
            required: true,
            validator: qyslValidate,
            trigger: 'change'
          }
        ],
        rksl: [{ required: true, validator: rkslValidate, trigger: 'change' }],
        djr: [{ required: true, message: '请输入登记人', trigger: 'blur' }],
        // bgly: [{ required: true, message: "请输入变更理由", trigger: "blur" }],

        // 下拉框
        xsckBh: [
          {
            required: true,
            message: '请选择进口出库',
            trigger: ['blur', 'change']
          }
        ],
        rkrq: [
          {
            required: true,
            message: '请选择入库日期',
            trigger: ['blur', 'change']
          }
        ],
        jbrName: [
          {
            required: true,
            message: '请选择经办人',
            trigger: ['blur', 'change']
          }
        ],
        ckId: [
          {
            required: true,
            message: '请选择仓库',
            trigger: ['blur', 'change']
          }
        ]
      },

      tableData: [],
      andleSelectionChangeData_obj: {}, // 运输证选中
      andleSelectionChangeData_id: '', // 选择中的进口证明ID
      xsckDtoList: [], // 进口出库编号下拉
      ckslList: [], // 单位下拉
      jingbanrenlist: [], // 经办人下拉
      jkzXz: false
    }
  },
  computed: {
    tableText() {
      switch (this.dialogType) {
        case 1:
          return this.table1
        case 2:
          return this.table2
        case 3:
          return this.table3
        default:
          return this.table1
      }
    }
    // sortableType() {
    //   switch (this.dialogType) {
    //     case 1:
    //       return ["1"];
    //     case 2:
    //       return ["1", "2"];
    //     case 3:
    //       return ["2", "3"];
    //     default:
    //       return [];
    //   }
    // },
  },
  beforeDestroy() {
    this.$bus.$off('fatherToChil')
  },
  mounted() {
    this.$nextTick(() => {
      this.$bus.on('fatherToChil', this.initCon)
    })
    // 2022/1/12 清除校验结果
    // this.$refs.Bottom_xkzxxForm.clearValidate();
    // 获取弹框显示数据
    this.hallData()
    userInfofLogin().then((res) => {
      if (res.status == 200) {
        this.djr = res.data.data.name
        if (!this.xkzxxForm.djrLabel) {
          this.xkzxxForm.djrLabel = this.djr
        }
      }
    })
    if (this.xkzBh) {
      // this.xkzxxForm.jkzBh = this.xkzBh;

    }
  },
  methods: {
    loadJKZ(jkzId) {
      getJKZ(this.xkzxxForm.rkType || this.searchCertType, jkzId).then((res) => {
        this.xsckDtoList = res.data.data.xsckDtoList
        this.xkzxxForm.jkzId = res.data.data.id
        this.andleSelectionChangeData_id = this.xkzxxForm.jkzId
        this.xkzxxForm.hxpBm = res.data.data.hxpBm
        this.xkzxxForm.hxpMc = res.data.data.hxpMc
        this.xkzxxForm.hfrq = res.data.data.hfrq
        this.xkzxxForm.krked = res.data.data.kgmed
        this.xkzxxForm.krkedDw = res.data.data.kgmedDw
        this.xkzxxForm.krkedDwLabel = res.data.data.kgmedDwLabel
        this.xkzxxForm.jkzBh = res.data.data.xkzBh

        // 进口许可证 运输证 进口出库编号列表 出口单位名称 统一社会信用代码 行政区划
        // this.xkzxxForm.yszBh = "";
        // this.xkzxxForm.xsckBh = "";
        // this.xkzxxForm.ckdwTyxydm = res.data.data.ckdwShtyxydm;
        // this.xkzxxForm.ckdwMc = res.data.data.ckdwMc;
        // this.xkzxxForm.ckdwXzqh = res.data.data.ckdwXzqh;
        // 可进口额度换算@y 2022/1/10
        if (
          this.xkzxxForm.krkedDwLabel == '毫升' ||
          this.xkzxxForm.krkedDwLabel == '克'
        ) {
          this.temp_kgmed = this.xkzxxForm.krked
        } else if (
          this.xkzxxForm.krkedDwLabel == '升' ||
          this.xkzxxForm.krkedDwLabel == '千克'
        ) {
          this.temp_kgmed = this.xkzxxForm.krked * 1000
        } else if (this.xkzxxForm.krkedDwLabel == '吨') {
          this.temp_kgmed = this.xkzxxForm.krked * 1000 * 1000
        }
        gethqdw(res.data.data.hxpBm).then((res) => {
          this.ckslList = res.data.data
        })

        this.jkzXz = true
      })
    },
    lengthValidate,
    bacsCkXqShow(id) {
      this.dgcsXqId = id
      this.dialogFormVisible = !this.dialogFormVisible
    },
    initCon(curRow, curType) {
      this.curRowObj = curRow
      this.curType = curType
    },
    // 关闭窗口
    handleCloseBindWarnStandard() {
      this.bgwindow = false
    },
    // @y 2022/1/10  改(孙工写)
    searchByForm() {
      if (this.dialogType == 1) {
        // 进口证明
        this.get_jkz_list()
      } else {
        // 运输证
        this.get_ysz_list()
      }
    },
    // 运输证/进口证明 查内部列表
    // @y 2022/1/10  改(孙工写)
    pagesizeChangeYszOrGmz(val, curType) {
      this.bgform.size = val
      if (curType == 1) {
        // 进口证明
        this.get_jkz_list()
      } else {
        // 运输证
        this.get_ysz_list()
      }
      // this.dialogShow(this.dialogType);
    },
    // @y 2022/1/10  改(孙工写)2022/1/10 @y
    handleCurrentChangeYszOrGmz(val, curType) {
      this.bgform.page = val
      if (curType == 1) {
        // 进口证明
        this.get_jkz_list()
      } else {
        this.get_ysz_list()
      }
    },
    // 获取 进口证明/运输证列表2022/1/10 @y 改(孙工写)
    initGmzOrYszList(curChooseType) {
      if (curChooseType === 2 && !this.andleSelectionChangeData_id) {
        this.$message('请先选择进口证明')
        return
      }
      this.dialogVisible = true
      this.dialogType = curChooseType
      // 变更参数
      this.bgform = {
        page: 1,
        size: 10,
        param: {
          hxpMc: '',
          xkzBh: '',
          beginRkrq: '',
          endRkrq: '',
          zt: ''
        }
      }
      if (curChooseType == 1) {
        // 查进口证明
        this.get_jkz_list()
      } else if (curChooseType == 2) {
        // 运输证
        this.get_ysz_list()
      }
    },
    // 2022/1/10 @y 查询进口证明数据 改(孙工写)
    get_jkz_list() {
      getJKZList(this.xkzxxForm.rkType || this.searchCertType, this.bgform).then((res) => {
        this.tableData = res.data.data.rows
        this.total = res.data.data.total
      })
    },
    // 获取运输证列表2022/1/10 @y 改(孙工写)
    get_ysz_list() {
      // this.bgform.param.jkzId = this.andleSelectionChangeData_id;
      if (!this.andleSelectionChangeData_id) {
        this.$message('请先选择进口证明')
        return
      }
      getYSZList(this.andleSelectionChangeData_id, this.bgform).then((res) => {
        this.tableData = res.data.data.rows
        this.total = res.data.data.total
      })
    },
    // 数量计算 @y2022/1/10
    hshuliangjS() {
      // 变更的时候 =>只有入库数量可以变更
      // 非变更的时候 其运数量和 损耗数量是 带数来的 因此不用比较 直接减
      this.xkzxxForm.shsl = this.accSubtr(this.xkzxxForm.qysl, this.xkzxxForm.rksl, 3)
      // if (!this.bgdisable) {
      //   this.xkzxxForm.shsl = (
      //     this.xkzxxForm.qysl - this.xkzxxForm.rksl
      //   ).toFixed(3);
      // } else {
      //   // 单位换算 求入库数量核算出来的单位
      //   if (this.xkzxxForm.rkslDw == "毫升" || this.xkzxxForm.rkslDw == "克") {
      //     this.temp_rksldw_hs = this.xkzxxForm.rksl.toFixed(3);
      //   } else if (
      //     this.xkzxxForm.rkslDw == "升" ||
      //     this.xkzxxForm.rkslDw == "千克"
      //   ) {
      //     this.temp_rksldw_hs = (this.xkzxxForm.rksl * 1000).toFixed(3);
      //   } else if (this.xkzxxForm.rkslDw == "吨") {
      //     this.temp_rksldw_hs = (this.xkzxxForm.rksl * 1000).toFixed(3);
      //   }
      //   // 求损耗数量
      //   if (
      //     this.xkzxxForm.shslDwLabel == "毫升" ||
      //     this.xkzxxForm.shslDwLabel == "克"
      //   ) {
      //     this.xkzxxForm.shsl = (
      //       this.xkzxxForm.qysl - this.temp_rksldw_hs
      //     ).toFixed(3);
      //   } else if (
      //     this.xkzxxForm.shslDwLabel == "升" ||
      //     this.xkzxxForm.shslDwLabel == "千克"
      //   ) {
      //     this.xkzxxForm.shsl = (
      //       (this.xkzxxForm.qysl * 1000 - this.temp_rksldw_hs) /
      //       1000
      //     ).toFixed(3);
      //   } else if (this.xkzxxForm.shslDwLabel == "吨") {
      //     this.xkzxxForm.shsl = (
      //       (this.xkzxxForm.qysl * 1000 * 1000 - this.temp_rksldw_hs) /
      //       1000000
      //     ).toFixed(3);
      //   }
      // }
    },
    accSubtr(arg1, arg2, f = 0) {
      let r1, r2, m, n
      try { r1 = arg1.toString().split('.')[1].length } catch (e) { r1 = 0 }
      try { r2 = arg2.toString().split('.')[1].length } catch (e) { r2 = 0 }
      m = Math.pow(10, Math.max(r1, r2))
      // 动态控制精度长度
      n = (r1 >= r2) ? r1 : r2
      return ((arg1 * m - arg2 * m) / m).toFixed(n + f)
    },
    // 获取详情数据
    hxqsjFZ(id) {
      getJKRK(id).then((res) => {
        this.xkzxxForm = res.data.data
        this.searchCertType = this.xkzxxForm.rkType || 'J'
        this.xkzxxForm.rkslDw = res.data.data.rkslDwLabel
        this.loadJKZ(this.xkzxxForm.jkzId)
        // if (this.xkzxxForm.rkslDw == "吨") {
        //   if (res.data.data.kgmedDwLabel == "吨") {
        //     this.xkzxxForm.krked = this.xkzxxForm.krked + this.xkzxxForm.rksl;
        //   } else if (
        //     res.data.data.kgmedDwLabel == "千克" ||
        //     res.data.data.kgmedDwLabel == "升"
        //   ) {
        //     this.xkzxxForm.krked = this.xkzxxForm.krked + (this.xkzxxForm.rksl /1000);
        //   } else if (
        //     this.xkzxxForm.rkslDw == "克" ||
        //     this.xkzxxForm.rkslDw == "豪升"
        //   ) {
        //     this.xkzxxForm.krked = this.xkzxxForm.krked + (this.xkzxxForm.rksl /1000000);
        //   }
        // } else if (
        //   this.xkzxxForm.rkslDw == "千克" ||
        //   this.xkzxxForm.rkslDw == "升"
        // ) {
        // }

        // 获取可进口额度 @y 便于运算
        if (res.data.data.kgmedDwLabel == '吨') {
          this.temp_kgmed = res.data.data.kgmed * 1000 * 1000
        } else if (
          res.data.data.kgmedDwLabel == '千克' ||
          res.data.data.kgmedDwLabel == '升'
        ) {
          this.temp_kgmed = res.data.data.kgmed * 1000
        } else if (
          res.data.data.kgmedDwLabel == '克' ||
          res.data.data.kgmedDwLabel == '毫升'
        ) {
          this.temp_kgmed = res.data.data.kgmed
        }
        gethqdw(res.data.data.hxpBm).then((res) => {
          this.ckslList = res.data.data
        })
        this.xkzxxForm.id = ''
      })
    },
    // 获取详情数据
    hxqsj(id) {
      getJKRK(id).then((res) => {
        this.xkzxxForm = res.data.data
        this.searchCertType = this.xkzxxForm.rkType || 'J'
        this.xkzxxForm.rkslDw = res.data.data.rkslDwLabel
        this.loadJKZ(this.xkzxxForm.jkzId)
        // 获取可进口额度 @y 便于运算
        if (res.data.data.kgmedDwLabel == '吨') {
          this.temp_kgmed = res.data.data.kgmed * 1000 * 1000
        } else if (
          res.data.data.kgmedDwLabel == '千克' ||
          res.data.data.kgmedDwLabel == '升'
        ) {
          this.temp_kgmed = res.data.data.kgmed * 1000
        } else if (
          res.data.data.kgmedDwLabel == '克' ||
          res.data.data.kgmedDwLabel == '毫升'
        ) {
          this.temp_kgmed = res.data.data.kgmed
        }
        gethqdw(res.data.data.hxpBm).then((res) => {
          this.ckslList = res.data.data
        })
        this.$refs.Top_xkzxxForm.resetFields()
        this.$refs.Bottom_xkzxxForm.resetFields()
      })
    },
    // 运输许可证下拉
    hyszxkchange(data) {
      // this.xkzxxForm.cydwMc = data;
      this.xkzxxForm.yszBh = data
      this.xkzxxForm.yszId = ''
      this.xkzxxForm.cydwTyxydm = ''
      this.xkzxxForm.cydwMc = ''
    },
    // 运输许可证 监听input 事件
    hinputYSZ(data) {
      this.xkzxxForm.yszBh = data
      this.xkzxxForm.yszId = ''
      this.xkzxxForm.cydwTyxydm = ''
      this.xkzxxForm.cydwMc = ''
    },

    // 选择经办人
    hjbrChange(data) {
      this.jingbanrenlist.forEach((item) => {
        if (data == item.value) {
          this.xkzxxForm.jbrId = item.value
          this.xkzxxForm.jbrName = item.label
        }
      })
    },
    // 入库数量 单位下拉
    hdanweichange(data) {
      this.ckslList.forEach((item) => {
        if (item.value == data) {
          this.xkzxxForm.rkslDw = item.label
          this.xkzxxForm.qyslDwmc = item.label
          this.xkzxxForm.qyslDw = item.value
          this.xkzxxForm.shslDwmc = item.label
          this.xkzxxForm.shslDw = item.value
          // 2022/1/11 @y 改 变更的时候 起运数量随入库数量单位变化而变化
          // 2022/1/10 @y 起运数量单位名称回显(根据入库数量带出来的)
          this.xkzxxForm.qyslDwLabel = item.label
          // 2022/1/10 @y 损耗数量单位名称回显(根据入库数量带出来的)
          this.xkzxxForm.shslDwLabel = item.label
          // 2022/1/10 @y 变更的时候 起运数量不随入库数量单位变化而变化
          // if (!this.bgdisable) {
          //   //2022/1/10 @y 起运数量单位名称回显(根据入库数量带出来的)
          //   this.xkzxxForm.qyslDwLabel = item.label;
          //   // 2022/1/10 @y 损耗数量单位名称回显(根据入库数量带出来的)
          //   this.xkzxxForm.shslDwLabel = item.label;
          // }
          this.hshuliangjS()
        }
      })
    },
    // 存放仓库下拉
    cfckChange(val) {
      this.cangkuxiala.filter((item, index) => {
        if (item.value == val) {
          this.xkzxxForm.ckId = item.value
          this.xkzxxForm.ckmc = item.label
          this.xkzxxForm.bgyId = item.ckbgyId
          this.xkzxxForm.bgyxm = item.ckbgy
          this.xkzxxForm.bgydh = item.ckbgyDh
        }
      })
    },
    // 确定选中进口证明
    hqueding() {
      this.dialogVisible = false
      if (this.dialogType == 1) {
        // 进口证明
        // 2022-1-19 范文静 全卫
        // var data = "";
        // if (this.xkzBh) {
        //   data = this.xkzBh;
        // } else {
        //   data = this.andleSelectionChangeData_id;
        // }
        if (!this.andleSelectionChangeData_id) return
        this.xkzxxForm.rkType = this.searchCertType
        getJKZ(this.xkzxxForm.rkType, this.andleSelectionChangeData_id).then((res) => {
          this.xsckDtoList = res.data.data.xsckDtoList
          this.xkzxxForm.jkzId = res.data.data.id
          this.xkzxxForm.hxpBm = res.data.data.hxpBm
          this.xkzxxForm.hxpMc = res.data.data.hxpMc
          this.xkzxxForm.hfrq = res.data.data.hfrq
          this.xkzxxForm.krked = res.data.data.kgmed
          this.xkzxxForm.krkedDw = res.data.data.kgmedDw
          this.xkzxxForm.krkedDwLabel = res.data.data.kgmedDwLabel
          this.xkzxxForm.jkzBh = res.data.data.xkzBh
          // 进口许可证 运输证 进口出库编号列表 出口单位名称 统一社会信用代码 行政区划
          this.xkzxxForm.yszBh = ''
          this.xkzxxForm.xsckBh = ''
          this.xkzxxForm.ckdwTyxydm = res.data.data.xsdwTyshxydm
          this.xkzxxForm.ckdwMc = res.data.data.xsdwMc
          this.xkzxxForm.ckdwXzqh = res.data.data.ckdwXzqh
          // 可进口额度换算@y 2022/1/10
          if (
            this.xkzxxForm.krkedDwLabel == '毫升' ||
            this.xkzxxForm.krkedDwLabel == '克'
          ) {
            this.temp_kgmed = this.xkzxxForm.krked
          } else if (
            this.xkzxxForm.krkedDwLabel == '升' ||
            this.xkzxxForm.krkedDwLabel == '千克'
          ) {
            this.temp_kgmed = this.xkzxxForm.krked * 1000
          } else if (this.xkzxxForm.krkedDwLabel == '吨') {
            this.temp_kgmed = this.xkzxxForm.krked * 1000 * 1000
          }
          gethqdw(res.data.data.hxpBm).then((res) => {
            this.ckslList = res.data.data
          })

          this.jkzXz = true
        })
      } else {
        this.xkzxxForm.yszBh = this.andleSelectionChangeData_obj.xkzBh
        this.xkzxxForm.cydwMc = this.andleSelectionChangeData_obj.ysdwMc
        this.xkzxxForm.yszId = this.andleSelectionChangeData_obj.id
        this.xkzxxForm.cydwTyxydm =
          this.andleSelectionChangeData_obj.ysdwTyshxydm
      }
    },

    // 获取弹框显示数据
    hallData() {
      // 搜索下拉仓库
      APIcangku().then((res) => {
        this.cangkuxiala = res.data.data
      })

      // 获取下拉经办人
      APIjingbanren().then((res) => {
        this.jingbanrenlist = res.data.data
      })
    },
    back() {
      this.$parent.xkzBh = ''
      this.$parent.pupopShow = false
      this.$parent.multipleSelection = []
    },

    // 提交申请
    htjsq() {
      this.$refs.Top_xkzxxForm.validate((val) => {
        if (!val) {
          setTimeout(() => {
            var isError = document.getElementsByClassName('is-error')
            isError[0].querySelector('input').focus()
          }, 100)
          return false
        }
        this.$refs.Bottom_xkzxxForm.validate((valid) => {
          if (!valid) {
            setTimeout(() => {
              var isError = document.getElementsByClassName('is-error')
              isError[0].querySelector('input').focus()
            }, 100)
            return false
          }
          if (valid) {
            this.xkzxxForm.zt = '01'
            this.ckslList.forEach((item) => {
              if (item.label == this.xkzxxForm.rkslDw) {
                this.xkzxxForm.rkslDw = item.value
              }
            })
            this.loading = true
            addOrUpdSaveJKRK(this.xkzxxForm).then((res) => {
              this.loading = false
              this.$parent.xkzBh = ''
              this.$parent.pupopShow = false
              this.$parent.multipleSelection = []
              setTimeout(() => {
                this.$parent.hchongzhi()
              }, 300)
            }).catch((res) => {
              this.loading = false
            })
          }
        })
      })
    },
    // 暂时保存
    ZSsave() {
      this.$refs.Top_xkzxxForm.validate((val) => {
        if (!val) {
          setTimeout(() => {
            var isError = document.getElementsByClassName('is-error')
            isError[0].querySelector('input').focus()
          }, 100)
          return false
        }
        this.$refs.Bottom_xkzxxForm.validate((valid) => {
          if (!valid) {
            setTimeout(() => {
              var isError = document.getElementsByClassName('is-error')
              isError[0].querySelector('input').focus()
            }, 100)
            return false
          }
          if (valid) {
            this.xkzxxForm.zt = '00'
            this.ckslList.forEach((item) => {
              if (item.label == this.xkzxxForm.rkslDw) {
                this.xkzxxForm.rkslDw = item.value
              }
            })
            this.loading = true
            addOrUpdSaveJKRK(this.xkzxxForm).then((res) => {
              this.loading = false
              this.$parent.xkzBh = ''
              this.$parent.pupopShow = false
              this.$parent.multipleSelection = []
              setTimeout(() => {
                this.$parent.hchongzhi()
              }, 300)
            }).catch((res) => {
              this.loading = false
            })
          }
        })
      })
    },
    htjbg() {
      this.$refs.Top_xkzxxForm.validate((val) => {
        if (!val) {
          setTimeout(() => {
            var isError = document.getElementsByClassName('is-error')
            isError[0].querySelector('input').focus()
          }, 100)
          return false
        }
        this.$refs.Bottom_xkzxxForm.validate((valid) => {
          if (!valid) {
            setTimeout(() => {
              var isError = document.getElementsByClassName('is-error')
              isError[0].querySelector('input').focus()
            }, 100)
            return false
          }
          if (valid) {
            var obj = {
              id: this.xkzxxForm.id,
              jkzId: this.xkzxxForm.jkzId,
              hxpBm: this.xkzxxForm.hxpBm,
              ckId: this.xkzxxForm.ckId,
              rksl: this.xkzxxForm.rksl,
              rkslDw: '',
              // @y2022/1/11 变更保存 文静 起运数量可以变更
              qysl: this.xkzxxForm.qysl,
              qyslDw: ''
            }
            this.ckslList.forEach((item) => {
              if (item.label == this.xkzxxForm.rkslDw) {
                obj.rkslDw = item.value
                obj.qyslDw = item.value
              }
            })
            changePdkc(obj).then((res) => {
              const duixaing = {
                id: this.xkzxxForm.id,
                dwId: this.xkzxxForm.dwId,
                rkbh: this.xkzxxForm.rkbh,
                hxpBm: this.xkzxxForm.hxpBm,
                ckId: this.xkzxxForm.ckId,
                rksl: this.xkzxxForm.rksl,
                rkrq: this.xkzxxForm.rkrq,
                bgly: this.xkzxxForm.bgly,
                rkslDw: obj.rkslDw,
                // 起运数量可变更 @y2022/1/11 文静改
                qysl: this.xkzxxForm.qysl,
                qyslDw: obj.qyslDw
              }
              if (res.data.data.type == 'success') {
                this.$confirm('是否确认提交变更?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                  this.loading = true
                  saveChangeApply(duixaing).then((res) => {
                    this.loading = false
                    this.$parent.htableDataList()
                    this.$parent.xkzBh = ''
                    this.$parent.pupopShow = false
                    this.$parent.multipleSelection = []
                    this.$message({
                      type: 'success',
                      message: '提交成功!'
                    })
                  }).catch((error) => {
                    this.loading = false
                  })
                })
              } else {
                this.$confirm(
                  "<span style='color:red'>" +
                  res.data.data.msg +
                  '</span>,是否确认提交变更?',
                  '提示',
                  {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    dangerouslyUseHTMLString: true,
                    type: 'warning'
                  }
                ).then(() => {
                  this.loading = true
                  saveChangeApply(duixaing).then((res) => {
                    this.loading = false
                    this.$parent.htableDataList()
                    this.$parent.xkzBh = ''
                    this.$parent.pupopShow = false
                    this.$parent.multipleSelection = []
                    this.$message({
                      type: 'success',
                      message: '提交成功!'
                    })
                  }).catch((error) => {
                    this.loading = false
                  })
                })
              }
            })
          }
        })
      })
    },
    // 点击进口证明 运输证
    dialogShow(e) {
      this.bgform = {
        page: 1,
        size: 1,
        param: {
          hxpMc: '',
          xkzBh: '',
          beginRkrq: '',
          endRkrq: '',
          zt: ''
        }
      }
      if (e == 2 && !this.andleSelectionChangeData_id) {
        this.$message('请先选择进口证明')
        return
      }
      this.dialogType = e
      this.dialogVisible = true
      this.tableData = []
      //  1 进口证明
      if (e == 1) {
        getJKZList(this.xkzxxForm.rkType || this.searchCertType, this.bgform).then((res) => {
          this.tableData = res.data.data.rows
          this.total = res.data.data.total
        })
      } else {
        // this.bgform.param.jkzId = this.andleSelectionChangeData_id;
        getYSZList(this.andleSelectionChangeData_id, this.bgform).then((res) => {
          this.tableData = res.data.data.rows
          this.total = res.data.data.total
        })
      }
    },
    // 进口证明运输证单选
    handleSelectionChange(val) {
      if (val.length !== 0) {
        if (this.dialogType == 1) {
          this.andleSelectionChangeData_id = val[0].id
        } else {
          this.andleSelectionChangeData_obj = val[0]
        }
      }
      if (val.length > 1) {
        this.$refs.xsckTable.clearSelection()
        this.$refs.xsckTable.toggleRowSelection(val.pop())
      }
    },
    // 删除全选按钮
    cellClass(row) {
      if (row.columnIndex === 0) {
        return 'disableheadselection'
      }
    }
  }
}
</script>
<style scoped lang='less'>
.xuanze {
  margin-left: 10px;
  color: #ffffff;
  width: 65px;
  height: 39px;
  background: #5377ff;
  border-radius: 2px;
}
.purchase_pupop {
  .purchase_form {
    padding-top: 10px;
  }
  width: 90%;
  max-width: 1200px;
  margin: auto;
  .title {
    margin-bottom: 40px;
    // margin-top: 40px;
  }
  .xkzxx {
    background-color: white;
    padding-left: 118px;
    padding-right: 118px;
    /* margin-top: 40px; */
    padding-top: 40px;
    padding-bottom: 20px;
    margin-bottom: 15px;
    .el-form {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .el-form-item {
        margin-right: 0;
        width: 45%;
        /deep/.el-form-item__content {
          display: flex !important;
        }
      }
    }
  }
  .rkxx {
    background-color: white;
    padding-left: 118px;
    padding-right: 118px;
    /* margin-top: 40px; */
    padding-top: 40px;
    margin-bottom: 15px;
    .el-form {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .el-form-item {
        margin-right: 0;
        width: 45%;
        /deep/.el-form-item__content {
          display: flex !important;
        }
      }
    }
    .buttonList {
      text-align: center;
      /* padding-top: 82px; */

      .zsbc {
        color: #333333;
        width: 148px;
        height: 60px;
        background: #ebebeb;
        border-radius: 5px;
        margin-right: 95px;
        margin-top: 80px;
        margin-bottom: 60px;
      }
      .tjsq {
        color: #ffffff;
        width: 148px;
        height: 60px;
        background: #4170ff;
        border-radius: 5px;
        margin-left: 95px;
        margin-top: 80px;
        margin-bottom: 60px;
      }
    }
  }
}
.el-date-editor {
  width: 100% !important;
}

/deep/ .el-dialog {
  width: 95%;
  max-width: 1600px;
}

/deep/ .disableheadselection > .cell .el-checkbox__inner {
  display: none !important;
}
.t_search_form {
  display: flex;
  margin-bottom: 10px;
}
.t_search_form .el-form-item {
  margin-right: 30px;
  margin-bottom: 0;
}
</style>
